import { BufferAttribute, BufferGeometry, Line, LineBasicMaterial } from "three"

export { Edge }

class Edge extends Line {
    constructor(vertex1, vertex2) {
        const positions = new Float32Array([
            vertex1.position[0], vertex1.position[1], vertex1.position[2],
            vertex2.position[0], vertex2.position[1], vertex2.position[2]
        ])

        const colours = new Float32Array([
            vertex1.colour[0], vertex1.colour[1], vertex1.colour[2],
            vertex2.colour[0], vertex2.colour[1], vertex2.colour[2]
        ])

        const geometry = new BufferGeometry()
        geometry.setAttribute('position', new BufferAttribute(positions, 3))
        geometry.setAttribute('color', new BufferAttribute(colours, 3))

        const material = new LineBasicMaterial({
            vertexColors: true,
            transparent: true,
            opacity: window.matchMedia('(prefers-color-scheme: dark)').matches ? .1 : .5,
        })

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", ({ matches }) => {
            material.opacity = matches ? .1 : .5
            material.needsUpdate = true
        })

        super(geometry, material)
    }

    /**
     * Updates the position of one of the edge vertices.
     * @param {number} index of the vertex to be updated
     * @param {import("three").Vector3} vector of the new position
     */
    update(index, vector) {
        const positionAttribute = this.geometry.getAttribute("position")

        positionAttribute.setXYZ(index, ...vector)
        positionAttribute.needsUpdate = true
    }
}